"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomerListForScanCenterCsv = getCustomerListForScanCenterCsv;
const papaparse_1 = require("papaparse");
const constants_1 = require("./constants");
function getCustomerListForScanCenterCsv({ data, header, }) {
    return (0, papaparse_1.unparse)(data.map(({ accountName, businessName, city, contactName, customerId, firstName, lastName, publicId, streetAddress, zipCode, }) => {
        return {
            [header.customerId]: customerId,
            [header.publicId]: publicId,
            [header.accountName]: accountName,
            [header.contactName]: contactName,
            [header.businessName]: businessName,
            [header.firstName]: firstName,
            [header.lastName]: lastName,
            [header.streetAddress]: streetAddress,
            [header.zipCode]: zipCode,
            [header.city]: city,
        };
    }), constants_1.customerListCsvConfig);
}
//# sourceMappingURL=get-customer-list-for-scan-center-csv.js.map